import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Input,
  ModalCloseButton,
  useDisclosure,
  NumberInput,
  NumberInputField,
  FormControl,
  Flex,
  Box,
  ModalFooter,
  FormLabel,
  Textarea
} from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'
import { BiSliderAlt } from 'react-icons/bi'
import { FiEdit2 } from 'react-icons/fi'
import { IoIosAddCircle } from 'react-icons/io'

import useParametrizationIncrementSupplier from '@hook/parametrization/use-incremet'

import Filter from '@component/Shared/Filter'
import SelectAsyncPaginateFromApiPost from '@component/Shared/FilterPaginationApiPost'

const ParametrizationIncrementSupplierCreate: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isToggled, setIsToggled] = useState(false)
  const {
    filterEdit,
    loadingEdit,
    paramsEdit,
    selecteds,
    handleUpdateEditParams,
    createData,
    updateDataIncrement
  } = useParametrizationIncrementSupplier()

  useEffect(() => {
    if (paramsEdit.estoqueDias !== 0) {
      setIsToggled(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])
  const handleToggleChange = () => {
    setIsToggled(!isToggled)
  }

  return (
    <>
      {selecteds.length > 0 ? (
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          leftIcon={<FiEdit2 />}
          colorScheme="green"
          variant="outline"
          onClick={onOpen}
        >
          Editar
        </Button>
      ) : (
        <Button
          fontSize={14}
          size="sm"
          leftIcon={<IoIosAddCircle />}
          colorScheme="blue"
          variant="outline"
          onClick={onOpen}
        >
          Adicionar
        </Button>
      )}
      <Modal
        isCentered
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
        motionPreset="slideInBottom"
        colorScheme="white"
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            <Flex>
              <Box p={2}>
                <BiSliderAlt />
              </Box>
              <Box p={2} pt={1} w={1200}>
                {selecteds.length > 0
                  ? 'Editar Incremento Estoque'
                  : 'Criar Incremento Estoque'}
              </Box>
            </Flex>
          </ModalHeader>

          <ModalCloseButton />
          <ModalBody bg="white" pt={0} py={4}>
            <FormControl isRequired>
              <Filter
                label="Loja"
                options={filterEdit.centers}
                isMulti={true}
                isDisabled={selecteds.length > 0}
                value={paramsEdit.lojaIds}
                onChange={value =>
                  handleUpdateEditParams({ name: 'lojaIds', value: value })
                }
                isLoading={loadingEdit}
              />
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <SelectAsyncPaginateFromApiPost
                label="Produto"
                apiUrl="/v1/Produto"
                isDisabled={selecteds.length > 0}
                value={paramsEdit.produtoIds}
                isMulti={true}
                onChange={value =>
                  handleUpdateEditParams({ name: 'produtoIds', value: value })
                }
              />
            </FormControl>

            <br></br>
            <FormControl isRequired>
              <FormLabel>Data Inicio</FormLabel>
              <Input
                borderBottomColor="black"
                type="date"
                value={paramsEdit.dataInicio}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'dataInicio',
                    value: value.target.value
                  })
                }
              ></Input>
            </FormControl>
            <br></br>
            <FormControl isRequired>
              <FormLabel>Data Fim</FormLabel>
              <Input
                borderBottomColor="black"
                type="date"
                value={paramsEdit.dataFim}
                onChange={value =>
                  handleUpdateEditParams({
                    name: 'dataFim',
                    value: value.target.value
                  })
                }
              ></Input>
            </FormControl>
            <br></br>

            <Flex>
              <Box pt={6}>
                <Button
                  fontSize={14}
                  size="sm"
                  color="orange"
                  iconColor="orange"
                  borderColor="orange"
                  colorScheme="orange"
                  onClick={() => handleToggleChange()}
                  variant={isToggled ? 'outline' : 'ghost'}
                >
                  Dias Estoque
                </Button>
              </Box>
              <Box pt={6}>
                <Button
                  fontSize={14}
                  size="sm"
                  color="green"
                  marginLeft={2}
                  iconColor="green"
                  borderColor="green"
                  colorScheme="green"
                  onClick={() => handleToggleChange()}
                  variant={isToggled ? 'ghost' : 'outline'}
                >
                  Incremento
                </Button>
              </Box>
            </Flex>

            <br></br>
            {isToggled ? (
              <>
                <FormControl isRequired>
                  <FormLabel>Dias Estoque</FormLabel>
                  <NumberInput
                    borderBottomColor="black"
                    value={paramsEdit.estoqueDias}
                    onChange={value =>
                      handleUpdateEditParams({
                        name: 'estoqueDias',
                        value: value
                      })
                    }
                  >
                    <NumberInputField />
                  </NumberInput>
                </FormControl>
              </>
            ) : (
              <>
                <FormControl isRequired>
                  <FormLabel>Incremento Estoque</FormLabel>
                  <NumberInput
                    borderBottomColor="black"
                    value={paramsEdit.incrementoEstoque}
                    onChange={value =>
                      handleUpdateEditParams({
                        name: 'incrementoEstoque',
                        value: value
                      })
                    }
                  >
                    <NumberInputField />
                  </NumberInput>
                </FormControl>
              </>
            )}

            <br></br>
            <FormControl>
              <FormLabel>Observação</FormLabel>
              <Textarea
                borderColor="black"
                value={paramsEdit.observation}
                onChange={value => {
                  handleUpdateEditParams({
                    name: 'observation',
                    value: value.target.value
                  })
                }}
              ></Textarea>
            </FormControl>
          </ModalBody>
          <ModalFooter
            bg="white"
            borderBottomLeftRadius={5}
            borderBottomRightRadius={5}
          >
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button
              bg="green.600"
              color="#fff"
              onClick={() => {
                if (selecteds.length > 0) {
                  updateDataIncrement(isToggled)
                  onClose()
                } else {
                  createData(isToggled)
                  onClose()
                }
              }}
              _hover={{
                bg: 'green.500'
              }}
              _active={{
                bg: 'green.500'
              }}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default ParametrizationIncrementSupplierCreate
